// Mokaleng IT mascot image. Used on the About page and as the default profile picture.
// To change it everywhere, replace src/assets/mokaleng-pro.jpg.
import mokalengProPic from '../assets/mokaleng-pro.jpg';

export default mokalengProPic;
